import { Process } from '../interfaces/Organization';

export class MProcess{
    public id: number;
    public name: string;
    public selected: boolean = false;

    constructor(process: Process){
        this.id = process.id;
        this.name = process.nombre
    }
}
